// extracted by mini-css-extract-plugin
module.exports = {"QuestionLabel":"styles_QuestionLabel__3-BxW","QuestionLabelHandler":"styles_QuestionLabelHandler__5MDAs","QuestionLabelContent":"styles_QuestionLabelContent__8zhdw"};